import React, { useState, useEffect } from "react";
import "../../Styles/RepresentativeForm.css";
import ApiService from "../../nhrc_apis/ApiService";
import { FaSyncAlt } from "react-icons/fa";

const { UploadAPI, AuthAPI } = ApiService;

function RepresentativeFormUniversity({ onBack, onComplete, membershipId, memberId }) {

  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const safeMembershipId =
    membershipId || localStorage.getItem("membershipId");

  const safeMemberId =
    memberId || localStorage.getItem("memberId");

  /* CAPTCHA */
  const [captcha, setCaptcha] = useState({ id: "", question: "" });
  const [userAnswer, setUserAnswer] = useState("");
  const [captchaValid, setCaptchaValid] = useState(false);
  const [verifying, setVerifying] = useState(false);

  /* FORM */
  const [formData, setFormData] = useState({
    collegeName: "",
    universityName: "",
    collegeCode: "",
    designation: "",
    department: "",
    state: "",
    district: "",
    pincode: "",
    address: "",
    experience: "",
    idFront: null,
    idBack: null,
    officialMail: "",
    personalMail: "",
    password: "",
    confirmPassword: "",
    mobile: "",
  });

  /* CAPTCHA LOAD */
  const generateCaptcha = async () => {
    try {
      const res = await AuthAPI.getCaptcha();

      setCaptcha({
        id: res?.data?.captcha_id,
        question: res?.data?.question,
      });

      setUserAnswer("");
      setCaptchaValid(false);
    } catch {
      alert("Failed to load captcha");
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  /* INPUT */
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  /* CAPTCHA VERIFY */
  const verifyCaptcha = async () => {
    if (!captcha.id || !userAnswer) {
      alert("Enter captcha");
      return;
    }

    try {
      setVerifying(true);

      await AuthAPI.verifyCaptcha({
        captcha_id: captcha.id,
        answer: userAnswer.trim(),
      });

      setCaptchaValid(true);
      alert("Captcha Verified ✅");

    } catch (err) {
      setCaptchaValid(false);
      alert(err?.response?.data?.detail || "Invalid captcha ❌");
      generateCaptcha();
    } finally {
      setVerifying(false);
    }
  };

  /* VALIDATION */
  const validateForm = () => {
    if (!safeMembershipId || !safeMemberId) {
      alert("Member ID or Membership ID missing");
      return false;
    }

    if (formData.password !== formData.confirmPassword) {
      alert("Password mismatch");
      return false;
    }

    if (!captchaValid) {
      alert("Verify captcha");
      return false;
    }

    if (!formData.idFront || !formData.idBack) {
      alert("Upload ID proofs");
      return false;
    }

    return true;
  };

  /* FILE UPLOAD */
  const uploadFile = async (file, type) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("membership_id", String(safeMembershipId));
    fd.append("file_type", type);

    const res = await UploadAPI.uploadFile(fd);

    return res.data?.fileUrl || res.data?.file_path || "";
  };

  /* SUBMIT */
  const handleRegister = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const front = await uploadFile(formData.idFront, "representative_front");
      const back = await uploadFile(formData.idBack, "representative_back");

      /* ✅ FIXED PAYLOAD (FLAT + SNAKE_CASE) */
      const payload = {
        member_id: Number(safeMemberId),
        membership_id: String(safeMembershipId),

        representative_id: `NHRC-REP-${Date.now()}`,
        institute_type: "University",

        college_name: formData.collegeName,
        university_name: formData.universityName,
        college_code: formData.collegeCode,
        designation: formData.designation,
        department: formData.department,
        state: formData.state,
        district: formData.district,
        pincode: formData.pincode,
        university_address: formData.address,
        experience: formData.experience,
        mobile_number: formData.mobile,

        id_proof_front: front,
        id_proof_back: back,

        official_mail_id: formData.officialMail,
        personal_mail: formData.personalMail,
        password: formData.password,

        captcha_id: captcha.id,
        captcha_answer: userAnswer.trim(),
      };

      console.log("✅ FINAL FIXED PAYLOAD:", payload);

      await onComplete(payload);

      setShowSuccess(true);

    } catch (err) {
      console.error("SUBMIT ERROR:", err);
      alert("Submit failed");
      generateCaptcha();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="repuni-wrapper">

      {!showSuccess ? (
        <div className="repuni-card">

          <h2 className="repuni-title">
            REPRESENTATIVE UNIVERSITY DETAILS
          </h2>

          <form onSubmit={handleRegister} className="represent-form">

            <div className="repuni-grid">

              {/* ✅ YOUR FIELDS UNCHANGED */}
              <div className="repuni-field">
                <label>College Name*</label>
                <input name="collegeName" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>University Name*</label>
                <input name="universityName" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>College Code*</label>
                <input name="collegeCode" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>Designation*</label>
                <select name="designation" onChange={handleChange} required>
                  <option value="">Select</option>
                  <option>TPO</option>
                  <option>Principal</option>
                  <option>HOD</option>
                  <option>Others</option>
                </select>
              </div>

              <div className="repuni-field">
                <label>Department*</label>
                <input name="department" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>State*</label>
                <input name="state" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>District*</label>
                <input name="district" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>Pincode*</label>
                <input name="pincode" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>Address*</label>
                <textarea name="address" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>Experience*</label>
                <input name="experience" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>ID Front*</label>
                <input type="file" name="idFront" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>ID Back*</label>
                <input type="file" name="idBack" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>Official Mail*</label>
                <input name="officialMail" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>Personal Mail*</label>
                <input name="personalMail" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>Password*</label>
                <input type="password" name="password" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>Confirm Password*</label>
                <input type="password" name="confirmPassword" onChange={handleChange} required />
              </div>

              <div className="repuni-field">
                <label>Mobile*</label>
                <input name="mobile" onChange={handleChange} required />
              </div>

            </div>

            {/* CAPTCHA */}
            <div className="repuni-captcha">
              <p>{captcha.question}</p>

              <input
                value={userAnswer}
                onChange={(e) => setUserAnswer(e.target.value)}
                required
              />

              <button type="button" onClick={generateCaptcha}>
                <FaSyncAlt />
              </button>

              <button type="button" onClick={verifyCaptcha}>
                Verify
              </button>
            </div>

            <div className="repuni-footer">
              <button type="button" onClick={onBack}>Back</button>

              <button type="submit" disabled={loading}>
                {loading ? "Submitting..." : "Register"}
              </button>
            </div>

          </form>
        </div>
      ) : (
        <div className="repuni-popup">
          <h2>🎉 Registration Successful</h2>
          <button onClick={onBack}>Continue</button>
        </div>
      )}

    </div>
  );
}

export default RepresentativeFormUniversity;